enum ApEditorMode {
    template = 'TEMPLATE',
    plan = 'PLAN',
}

export default ApEditorMode;
